<template>
    <div>
        <div class="header">
            <h3>{{ $t('domain_parking') }}</h3>
        </div>

        <el-button type="primary" class="mb15" @click="create">{{ $t('add_domain') }}</el-button>

        <el-table
                v-loading="loading"
                :data="data"
                style="width: 100%">

            <el-table-column
                    prop="name"
                    :label="$t('domain')">
            </el-table-column>

            <!--<el-table-column-->
                    <!--prop="status"-->
                    <!--:label="$t('status')"-->
                    <!--width="180">-->
                <!--<template slot-scope="scope">-->
                    <!--<el-tag type="warning" v-if="scope.row.status === 0" disable-transitions>{{ $t('domain_status.pending') }}</el-tag>-->
                    <!--<el-tag type="success" v-if="scope.row.status === 1" disable-transitions>{{ $t('domain_status.active') }}</el-tag>-->
                    <!--<el-tag type="success" v-if="scope.row.status === -1" disable-transitions>{{ $t('domain_status.inactive') }}</el-tag>-->
                <!--</template>-->
            <!--</el-table-column>-->

            <el-table-column
                    prop="created_at"
                    :label="$t('created_at')"
                    width="180">
                <template slot-scope="scope">
                    {{ scope.row.created_at | moment("YYYY-MM-DD HH:mm") }}
                </template>
            </el-table-column>
            <el-table-column
                    width="140">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button size="mini" @click="edit(scope.row)"><i class="material-icons"></i></el-button>
                        <el-button size="mini" type="danger" @click="remove(scope.row)"><i class="material-icons">&#xe872;</i></el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog v-on:closed="formReset" :title="model.id ? $t('edit_domain'): $t('create_domain')" :visible.sync="dialogFormVisible">
            <el-form :model="model" status-icon label-width="170px">

                <el-alert
                        title=""
                        style="margin-bottom: 15px"
                        type="info"
                        :closable="false"
                        show-icon>
                    {{ $t('domain_parking_info') }}
                </el-alert>

                <el-form-item :label="$t('domain')" prop="name" :error="error_form.name">
                    <el-input v-model="model.name" placeholder="your-domain.com"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="save" :loading="loading_form">{{ model.id ? $t('save'): $t('create') }}</el-button>
                    <el-button @click="dialogFormVisible = false">{{ $t('cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "Domain",
        data () {
            return {
                data: [],
                loading: false,
                model: {},
                error_form: {},
                dialogFormVisible: false,
                loading_form: false,
            };
        },
        created () {
            this.fetchData();
        },
        methods: {
            fetchData () {
                this.loading = true;
                this.$axios.get('/domains').then((res) => {
                    this.data = res.data;
                    this.loading = false;
                })
            },
            formReset () {
                this.model = {
                    id: null,
                    name: ''
                };
                this.error_form = {};
                this.loading_form = false;
            },
            edit (model) {
                this.dialogFormVisible=true;
                this.error_form = {};
                this.model={
                    id: model.id,
                    name: model.name
                };
            },
            create () {
                this.dialogFormVisible=true;
                this.formReset();
            },
            save () {
                this.loading_form=true;
                if (this.model.id) {
                    this.$axios.patch('/domains/' + this.model.id, this.model).then(() => {
                        this.error_form = {};
                        this.loading_form = false;
                        this.dialogFormVisible=false;
                        this.fetchData()
                    }).catch((error) => {
                        this.error_form = error.response.data;
                        this.loading_form=false;
                    });
                } else {
                    this.$axios.post('/domains', this.model).then(() => {
                        this.error_form = {};
                        this.loading_form = false;
                        this.dialogFormVisible=false;
                        this.fetchData()
                    }).catch((error) => {
                        this.error_form = error.response.data;
                        this.loading_form=false;
                    });
                }
            },
            remove (model) {
                this.$confirm(this.$t('confirm_delete_domain'), this.$t('confirm_title'), {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    this.$axios.delete('/domains/' + model.id ).then(() => {
                        this.$message({
                            type: 'success',
                            message: 'Домен удален'
                        });
                        this.loading = false;
                        this.data.splice(this.data.indexOf(model), 1);
                    });
                }).catch(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<style lang="scss" >


</style>